/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Routes } from "react-router-dom";
import App from "App";
import { AuthProvider } from "context/AuthProvider";
// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { LocalidadesProvider } from "context/LocalidadesProvider";

ReactDOM.render(
  <HashRouter>
    <MaterialUIControllerProvider>
      <AuthProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </AuthProvider>
    </MaterialUIControllerProvider>
  </HashRouter>,
  document.getElementById("root")
);
